import UpgradeWidgetContainer from './upgrade_widget_container';

const UpgradeWidget = UpgradeWidgetContainer;
export default UpgradeWidget;
